var __jsx = React.createElement;
import * as React from 'react';
import styled from 'styled-components';
import * as ds from '@bob/design-system';
import { styles as S } from '@bob/design-system';
import { SocialShare } from './SocialShare';
export function ShareGroup(_ref) {
  var title = _ref.title,
      text = _ref.text,
      url = _ref.url,
      children = _ref.children,
      buttonLabel = _ref.buttonLabel;
  return __jsx(ShareGroupWrapper, null, children, __jsx(SocialShare, {
    url: url,
    title: title,
    text: text,
    buttonLabel: buttonLabel
  }));
}
var ShareGroupWrapper = styled.div.withConfig({
  displayName: "ShareGroup__ShareGroupWrapper",
  componentId: "sc-17raigl-0"
})(["display:flex;flex-direction:column;align-items:center;", "{text-align:center;margin-bottom:20px;}", "{@media screen and (", "){display:flex;margin-bottom:24px;}}", "{display:block;margin-top:6px;margin-bottom:20px;padding-left:25%;padding-right:25%;}@media screen and (", "){margin-top:40px;", "{width:290px;}", "{margin:35px 0px;}}"], S.copy.Text1, ds.SocialShare, ds.breakpoint.TABLET, ds.Button, ds.breakpoint.TABLET, S.copy.Text1, ds.Button);